export default "__VITE_ASSET__17d37e4f__"